export enum Platform {
  JuvOnline = "JuvOnline"
}
